var exports = {
  "zr": "MacPermissionsSettingsRow.module__root___cDJSZW",
  "h_": "MacPermissionsSettingsRow.module__description___cDJSZW",
  "Mn": "MacPermissionsSettingsRow.module__lines___cDJSZW",
  "n8": "MacPermissionsSettingsRow.module__line___cDJSZW",
  "Om": "MacPermissionsSettingsRow.module__dot___cDJSZW",
  "Yf": "MacPermissionsSettingsRow.module__dotAllowed___cDJSZW",
  "H0": "MacPermissionsSettingsRow.module__dotDenied___cDJSZW",
  "Pf": "MacPermissionsSettingsRow.module__label___cDJSZW",
  "ZY": "MacPermissionsSettingsRow.module__trailing___cDJSZW",
  "XI": "MacPermissionsSettingsRow.module__action___cDJSZW",
  "TQ": "MacPermissionsSettingsRow.module__allowed___cDJSZW",
  "IR": "MacPermissionsSettingsRow.module__screenReaderOnly___cDJSZW",
  "v9": "MacPermissionsSettingsRow.module__advice___cDJSZW",
};

module.exports = exports;
